import { Gamecloud } from "../../../../gamecloud";
import { BF4MapcycleUI } from "./BF4MapcycleUI";
import { IMapItemData } from "../../../../interface";
import { Sortable, Plugins } from '@shopify/draggable/lib/es5/draggable.bundle';

interface ISortableEvent {
  data: {
    dragEvent: any;
    newContainer: any;
    newIndex: number;
    oldContainer: any;
    oldIndex: number;
  }
}

/**
 * Mapcycle
 * @TODO: make it usable for other games
 * @supports: Battlefield 4
 */

export class BF4Mapcycle extends Gamecloud {
  // sortable instance
  private sortable = null;

  public constructor(private ui: BF4MapcycleUI, private data: IMapItemData[], private form: any) {
    super();

    // enable add button
    this.ui.enableSaveButton();

    // listen to add button click
    this.ui.onSaveButtonClick(this.handleAddButtonClick.bind(this));

    // render and init draggable
    this.ui.render(this.data, this.form).then(() => {
      this.sortable = this.initDraggable();
    });

    // listen to delete even
    window.addEventListener('removemap', (event) => {
      this.delete(event);
    });
  }

  /**
   * Handle save button click
   * Pushing data to array and render again
   */
  private handleAddButtonClick(data: IMapItemData) {
    this.data.push(data);
    this.render();
  }

  /**
   * Render the maps
   */
  private render() {
    this.ui.render(this.data, this.form);
  }

  /**
   * Remove map from array
   * index will provided by event
   * @param event - custom event
   */
  private delete(event: any) {
    this.data = this.data.filter((item, index) => index !== event.detail.index);
    this.render();
  }

  /**
   * init draggable feature
   * reorder after drop
   */
  private initDraggable() {
    const containerSelector = '.mapcycle__maps';
    const containers = document.querySelectorAll(containerSelector);

    if (containers.length === 0) {
      return false;
    }

    const sortable = new Sortable(containers, {
      draggable: '.map',
      delay: 200,
      mirror: {
        appendTo: containerSelector,
        constrainDimensions: true,
      },
    });

    //listen to dropevent
    sortable.on('sortable:stop', (ev: ISortableEvent) => {
      this.data = this.reOrder(ev, this.data);
      this.render();
    });

    return sortable;
  }

  /**
   * Reorder the data
   * @param event - drop event
   */
  private reOrder(event, originalArray) {
    const movedItem = originalArray.find((item, index) => index === event.oldIndex);
    const remainingItems = originalArray.filter((item, index) => index !== event.oldIndex);

    const reorderedItems = [
      ...remainingItems.slice(0, event.newIndex),
      movedItem,
      ...remainingItems.slice(event.newIndex)
    ];

    return reorderedItems;
  }
}
